import { harmEnum, lawEnum } from './sharedStrings.types';

export const productFilterSet = {
    application: {
        'grx': [
            "azure",
            "bing",
            "outlook",
            "skype",
            "sway",
            "powerpoint",
            "word",
            "excel",
            "xbox",
            "linkedIn",
            "clipchamp",
            "forza",
            "github",
            "groupme",
            "loop",
            "mCommunity",
            "mFeedback",
            "mForms",
            "msn",
            "mStores",
            "mWhiteboard",
            "minecraft",
            "onedrive",
            "sharepoint",
            "teams"
        ],
        'rac': [
            "azure",
            "bingSearch",
            "bingImageCreatorOrBingVideoCreator",
            "calendar",
            "copilot",
            "excel",
            "forza",
            "github",
            "groupme",
            "linkedIn",
            "loop",
            "mAdvertising",
            "mForms",
            "storesAPS",
            "storesWindows",
            "storesXboxConsole",
            "storesXboxCloud",
            "maiPlayground",
            "teams",
            "mTodo",
            "minecraft",
            "minecraftMarketplace",
            "msn",
            "nugetGallery",
            "onedrive",
            "onenote",
            "outlook",
            "powerpoint",
            "surface",
            "skype",
            "mStores",
            "visio",
            "windows",
            "word",
            "xbox",
            "storesXboxCom",
            "storesXboxPC",
        ],
        'appeals': [
            "azure",
            "bing",
            "outlook",
            "skype",
            "sway",
            "powerpoint",
            "word",
            "excel",
            "xbox",
            "linkedIn"
        ],
        'pForms': [
            "azure",
            "bing",
            "calendar",
            "copilot",
            "excel",
            "forza",
            "github",
            "groupme",
            "linkedIn",
            "mAdvertising",
            "mForms",
            "mLists",
            "storesAPS",
            "storesWindows",
            "storesXboxConsole",
            "storesXboxCloud",
            "teams",
            "mTodo",
            "minecraft",
            "minecraftMarketplace",
            "msn",
            "nugetGallery",
            "onedrive",
            "onenote",
            "outlook",
            "powerpoint",
            "surface",
            "skype",
            "mStores",
            "visio",
            "windows",
            "word",
            "xbox",
            "storesXboxCom",
            "storesXboxPC",
            "other"
        ],
    },
    agency: {
        'france': [
            "azure",
            "bing",
            "outlook",
            "skype",
            "sway",
            "powerpoint",
            "word",
            "excel",
            "xbox",
            "linkedIn",
            "clipchamp",
            "forza",
            "github",
            "groupme",
            "loop",
            "mAdvertising",
            "mCommunity",
            "mDesigner",
            "mFeedback",
            "mForms",
            "mPhotos",
            "msn",
            "mStores",
            "mWhiteboard",
            "minecraft",
            "sharepoint",
            "teams"
        ],
        'germany': [
            "azure",
            "bing",
            "outlook",
            "skype",
            "sway",
            "powerpoint",
            "word",
            "excel",
            "xbox",
            "linkedIn",
            "clipchamp",
            "forza",
            "github",
            "groupme",
            "loop",
            "mAdvertising",
            "mCommunity",
            "mDesigner",
            "mFeedback",
            "mForms",
            "mPhotos",
            "msn",
            "mStores",
            "mWhiteboard",
            "minecraft",
            "sharepoint",
            "teams"
        ]
    }
}

export const harmFilterSet = {
    application: {
        'grx': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
        ],
        'rac': [
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_RegulatedGoodsServices_AlcoholTobacco.toString(),
            harmEnum.rac_AlcoholTobaccoDrugs.toString(),
            harmEnum.rac_ProfanityAndVulgarity.toString(),
            harmEnum.rac_Grooming.toString(),
            harmEnum.rac_EatingDisorders.toString(),
            harmEnum.rac_ExposureOfPersonalInformation.toString(),
            harmEnum.rac_FirearmsAndWeapons.toString(),
            harmEnum.rac_Extortion.toString(),
            harmEnum.rac_OffTopic.toString(),
            harmEnum.rac_other.toString()
        ],
        'appeals': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.rac_other.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString()
        ],
        'pForms': [
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_RegulatedGoodsServices_AlcoholTobacco.toString(),
            harmEnum.rac_ProfanityAndVulgarity.toString(),
            harmEnum.rac_other.toString()
        ],
    },
    agency: {
        'france': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        'germany': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.rac_other.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString()
        ]
    },
    product: {
        'azure': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        // Bing cannot be removed as there are references in grx, appeals
        'bing': [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        // Harms list of Bing Search and Creator are not final and will be updated in subsequent PRs
        'bingSearch': [
            harmEnum.CSEA.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
        ],
        'bingImageCreatorOrBingVideoCreator': [
            harmEnum.CSEA.toString(),
            harmEnum.other.toString(),
        ],
        "calendar": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "clipchamp": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "copilot": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "excel": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "forza": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "github": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "groupme": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "linkedIn": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "loop": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mAdvertising": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mCommunity": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mDesigner": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mFeedback": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_other.toString()
        ],
        "mForms": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mLearn": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mLists": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mMakecode": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mPhotos": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "msn": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mStores": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_other.toString()
        ],
        "mTodo": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "mWhiteboard": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "minecraft": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "minecraftMarketplace": [
            harmEnum.Infringement.toString(),
            harmEnum.rac_Infringement.toString()
        ],
        "nugetGallery": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "onedrive": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "onenote": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "outlook": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "powerpoint": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "sharepoint": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "skype": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "storesAPS": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        storesWindows: [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        storesXboxCom: [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        storesXboxConsole: [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        storesXboxPC: [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "surface": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "sway": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "storesXboxCloud": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "teams": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "visio": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "windows": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "word": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "xbox": [
            harmEnum.BullyingAndHarassment.toString(),
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.SexualSolicitation.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.CoordinationOfHarm.toString(),
            harmEnum.ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.FraudPhishingOrScam.toString(),
            harmEnum.VirusSpywareOrMalware.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.other.toString(),
            harmEnum.rac_BullyingAndHarassment.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_SexualSolicitation.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_CoordinationOfHarm.toString(),
            harmEnum.rac_ThreatsIncitementAndGlorificationOfViolence.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_FraudPhishingOrScam.toString(),
            harmEnum.rac_VirusSpywareOrMalware.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString(),
            harmEnum.rac_other.toString()
        ],
        "maiPlayground": [
            harmEnum.CSEA.toString(),
            harmEnum.GraphicViolenceAndGore.toString(),
            harmEnum.HateSpeech.toString(),
            harmEnum.NonConsensualImageryAndExtortion.toString(),
            harmEnum.SuicideAndSelfInjury.toString(),
            harmEnum.TVEC.toString(),
            harmEnum.Trafficking.toString(),
            harmEnum.Spam.toString(),
            harmEnum.AdultAndSexual.toString(),
            harmEnum.Infringement.toString(),
            harmEnum.rac_CSEA.toString(),
            harmEnum.rac_GraphicViolenceAndGore.toString(),
            harmEnum.rac_HateSpeech.toString(),
            harmEnum.rac_NonConsensualImageryAndExtortion.toString(),
            harmEnum.rac_SuicideAndSelfInjury.toString(),
            harmEnum.rac_TVEC.toString(),
            harmEnum.rac_Trafficking.toString(),
            harmEnum.rac_Spam.toString(),
            harmEnum.rac_AdultAndSexual.toString(),
            harmEnum.rac_Infringement.toString()
        ],
    }
}

export const lawFilterSet = {
    application: {
        'grx': [
            lawEnum.nz_fvpca.toString(),
            lawEnum.eu_tcr.toString(),
            lawEnum.au_osa.toString(),
            lawEnum.au_bose.toString(),
            lawEnum.au_avm.toString(),
            lawEnum.us_ca_cmr.toString(),
            lawEnum.us_ca_cpa.toString(),
            lawEnum.us_ca_dsp.toString(),
            lawEnum.us_ca_ovpa.toString(),
            lawEnum.sk_na.toString(),
            lawEnum.sk_tba.toString(),
            lawEnum.in_ig.toString(),
            lawEnum.ph_osaec.toString(),
            lawEnum.ph_csaem.toString(),
            lawEnum.th_cca.toString(),
            lawEnum.notApplicable.toString()
        ],
        'rac': [lawEnum.notApplicable.toString()],
        'appeals': [lawEnum.notApplicable.toString()],
        'pForms': [lawEnum.notApplicable.toString()]
    },
    agency: {
        'france': [
            lawEnum.nz_fvpca.toString(),
            lawEnum.eu_tcr.toString(),
            lawEnum.au_osa.toString(),
            lawEnum.au_bose.toString(),
            lawEnum.au_avm.toString(),
            lawEnum.us_ca_cmr.toString(),
            lawEnum.us_ca_cpa.toString(),
            lawEnum.us_ca_dsp.toString(),
            lawEnum.us_ca_ovpa.toString(),
            lawEnum.sk_na.toString(),
            lawEnum.sk_tba.toString(),
            lawEnum.in_ig.toString(),
            lawEnum.ph_osaec.toString(),
            lawEnum.ph_csaem.toString(),
            lawEnum.th_cca.toString(),
            lawEnum.notApplicable.toString()
        ],
        'germany': [
            lawEnum.eu_tcr.toString(),
            lawEnum.notApplicable.toString()
        ]
    }
}
